import React from "react";
import CreateStore from "components/features/store/create/Index";
import UpdateStore from "../components/UpdateStoreComponent";
import StoreList from "./storeList";

const StoreViewController = ({ defaultMode = "list", as = "page", ...rest }) => {
  const [currentMode, setCurrentMode] = React.useState(defaultMode); // list, create, update
  const [storeId, setStoreId] = React.useState(null);
  React.useEffect(() => {
    if (defaultMode) {
      setCurrentMode(defaultMode);
    }
  }, [defaultMode]);

  return (
    <>
      {currentMode === "list" && (
        <StoreList as={as} setCurrentMode={setCurrentMode} setStoreId={setStoreId} {...rest} />
      )}
      {currentMode === "create" && (
        <CreateStore as={as} setCurrentMode={setCurrentMode} storeId={storeId} {...rest} />
      )}
      {currentMode === "update" && (
        <UpdateStore as={as} setCurrentMode={setCurrentMode} storeId={storeId} {...rest} />
      )}
    </>
  );
};

export default StoreViewController;
